<div class="modal-overlay" routerLink="/dash/temas">
  <div
    class="modal-container"
    (click)="$event.stopPropagation()"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
  >
    <!-- SIDEBAR -->
    <aside class="theme-sidebar">
      <!-- Partner header -->
      <div class="sidebar-partner-header">
        <p class="partner-label">Parceiro</p>
        <p class="partner-name">{{ partner?.name }}</p>
        <p class="partner-meta">{{ themesFormArray.length }} temas · {{ companiesCount }} empresas</p>
      </div>

      <!-- Theme list -->
      <ul class="theme-list">
        <ng-container *ngFor="let ctrl of themesFormArray.controls; let i = index; trackBy: trackByIndex">
          <li
            class="theme-list-item"
            [class.active]="selectedThemeIndex === i"
            [class.theme-list-item--unsaved]="!ctrl.get('id')?.value"
            [style.background-color]="
              selectedThemeIndex === i ? ctrl.get('totemPrimaryColor')?.value || ctrl.get('primaryColor')?.value : null
            "
            (click)="selectTheme(i)"
          >
            <div class="theme-list-info">
              <p class="theme-list-name" [style.color]="selectedThemeIndex === i ? '#ffffff' : null">
                Tema {{ ctrl.get('themeName')?.value || 'Sem nome' }}
              </p>
              <p class="theme-list-companies" [style.color]="selectedThemeIndex === i ? '#ffffff' : null">
                {{ getThemeCompanyNames(i) }}
              </p>
            </div>
          </li>
        </ng-container>

        <li *ngIf="themesFormArray.length === 0" class="theme-list-empty">Nenhum tema cadastrado</li>
      </ul>

      <!-- Sidebar footer -->
      <div class="sidebar-footer">
        <ng-container *ngIf="themesFormArray.length > 0">
          <button
            *isAllowed="[ERoleAdminString.Admin, 'theme.create']"
            type="button"
            class="btn btn--secondary sidebar-new-btn"
            (click)="addNewTheme()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="icon-sm"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            Novo tema
          </button>
        </ng-container>
        <ng-container *ngIf="themesFormArray.length > 0">
          <ng-container *isAllowed="[ERoleAdminString.Admin, 'theme.create']">
            <input
              #sidebarImportInput
              type="file"
              accept=".json"
              style="display: none"
              (change)="onImportJson($event)"
            />
            <button type="button" class="btn btn--import sidebar-new-btn" (click)="sidebarImportInput.click()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon-sm"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                />
              </svg>
              Importar tema (json)
            </button>
          </ng-container>
        </ng-container>
      </div>
    </aside>

    <!-- EDIT PANEL -->
    <div class="edit-panel" *ngIf="themesFormArray.length > 0">
      <div [formGroup]="selectedThemeForm" class="edit-panel-inner" (click)="activeColorKey = null">
        <!-- Topbar -->
        <div class="panel-topbar" [style.background-color]="effectivePrimaryColor">
          <ng-container *ngIf="selectedThemeForm.get('logoUrl')?.value; else topbarDot">
            <div class="theme-logo-thumb">
              <img [src]="selectedThemeForm.get('logoUrl')?.value" class="theme-logo-img" />
            </div>
          </ng-container>
          <ng-template #topbarDot> </ng-template>
          <div class="topbar-info">
            <h1 class="topbar-theme-name" style="color: #ffffff">
              Tema {{ selectedThemeForm.get('themeName')?.value || 'Novo tema' }}
            </h1>
            <p class="topbar-companies" style="color: rgba(255, 255, 255, 0.6)">
              {{ selectedThemeCompanyNames }}
            </p>
          </div>

          <!-- Topbar actions -->
          <div class="topbar-actions">
            <ng-container *isAllowed="[ERoleAdminString.Admin, 'theme.edit']">
              <button
                *ngIf="selectedThemeForm.get('id')?.value"
                type="button"
                class="topbar-btn topbar-btn--ghost-danger"
                [disabled]="isSaving"
                (click)="deleteTheme()"
              >
                Excluir
              </button>
              <button
                *ngIf="selectedThemeForm.get('id')?.value"
                type="button"
                class="topbar-btn topbar-btn--solid"
                [style.color]="effectivePrimaryColor"
                [disabled]="isSaving"
                (click)="saveTheme()"
              >
                {{ isSaving ? 'Salvando...' : 'Salvar tema' }}
              </button>
            </ng-container>
            <ng-container *isAllowed="[ERoleAdminString.Admin, 'theme.create']">
              <button
                *ngIf="!selectedThemeForm.get('id')?.value"
                type="button"
                class="topbar-btn topbar-btn--solid"
                [style.color]="effectivePrimaryColor"
                [disabled]="isSaving"
                (click)="saveTheme()"
              >
                {{ isSaving ? 'Salvando...' : 'Criar tema' }}
              </button>
            </ng-container>
          </div>

          <button
            type="button"
            class="modal-close-btn"
            routerLink="/dash/temas"
            [style.background]="'rgba(255,255,255,0.15)'"
            style="color: #ffffff"
          >
            ✕
          </button>
        </div>

        <!-- Scrollable content -->
        <div class="panel-content">
          <!-- Identidade (sempre visível) -->
          <section class="panel-section">
            <div class="flex gap-4">
              <div class="form-group flex-1">
                <label class="form-label">Nome do tema</label>
                <input
                  type="text"
                  formControlName="themeName"
                  class="form-input w-full"
                  placeholder="Digite o nome do tema"
                  [ngClass]="{
                    'border-red-500':
                      selectedThemeForm.get('themeName')?.invalid && selectedThemeForm.get('themeName')?.touched
                  }"
                />
                <p
                  *ngIf="selectedThemeForm.get('themeName')?.invalid && selectedThemeForm.get('themeName')?.touched"
                  class="text-red-500 text-xs mt-1"
                >
                  O nome do tema é obrigatório.
                </p>
              </div>

              <div class="form-group flex-1" *isAllowed="[ERoleAdminString.Admin, 'theme.edit']">
                <label class="form-label">Empresa</label>
                <select
                  class="form-input w-full"
                  style="height: auto; padding-top: 0.5rem; padding-bottom: 0.5rem"
                  formControlName="companyIds"
                  [class.border-red-500]="
                    selectedThemeForm.get('companyIds')?.invalid && selectedThemeForm.get('companyIds')?.touched
                  "
                >
                  <option [ngValue]="null">Selecione a empresa</option>
                  <option *ngFor="let company of availableCompanies" [value]="company.id">{{ company.name }}</option>
                </select>
                <p
                  *ngIf="selectedThemeForm.get('companyIds')?.invalid && selectedThemeForm.get('companyIds')?.touched"
                  class="text-red-500 text-xs mt-1"
                >
                  Selecione uma empresa.
                </p>
                <p class="field-hint">
                  Esse tema será usado em todos os setups dessa empresa do parceiro {{ partner?.name }}.
                </p>
              </div>
            </div>
          </section>

          <!-- Tab bar Desktop / Mobile -->
          <div class="config-tabs">
            <button
              type="button"
              class="config-tab"
              [class.active]="activeTab === 'desktop'"
              [style.color]="activeTab === 'desktop' ? effectivePrimaryColor : null"
              (click)="activeTab = 'desktop'"
            >
              Desktop (Totens)
            </button>
            <button
              type="button"
              class="config-tab"
              [class.active]="activeTab === 'mobile'"
              [style.color]="activeTab === 'mobile' ? effectivePrimaryColor : null"
              (click)="activeTab = 'mobile'"
            >
              Mobile (Gertec)
            </button>
            <button
              type="button"
              class="config-tab"
              [class.active]="activeTab === 'skincare'"
              [style.color]="activeTab === 'skincare' ? effectivePrimaryColor : null"
              (click)="activeTab = 'skincare'"
            >
              Skincare
            </button>
            <button
              type="button"
              class="config-tab"
              [class.active]="activeTab === 'standby'"
              [style.color]="activeTab === 'standby' ? effectivePrimaryColor : null"
              (click)="activeTab = 'standby'"
            >
              Standby
            </button>
            <button
              type="button"
              class="config-tab"
              [class.active]="activeTab === 'home'"
              [style.color]="activeTab === 'home' ? effectivePrimaryColor : null"
              (click)="activeTab = 'home'"
            >
              Tela inicial
            </button>
          </div>

          <!-- ── DESKTOP TAB ── -->
          <ng-container *ngIf="activeTab === 'desktop'">
            <!-- Logos Desktop -->
            <section class="panel-section">
              <h2 class="section-title">Logos - Desktop</h2>
              <div *ngFor="let slot of desktopLogoSlots" class="form-group">
                <label class="form-label">
                  {{ slot.title }} <span class="logo-badge" style="margin-left: 4px">{{ slot.badge }}</span>
                  <span *ngIf="!slot.required" style="color: #9ca3af; font-size: 11px; margin-left: 4px"
                    >(opcional)</span
                  >
                </label>
                <input
                  type="text"
                  [formControlName]="slot.field"
                  class="form-input w-full"
                  placeholder="https://storage.googleapis.com/..."
                  [ngClass]="{
                    'border-red-500':
                      slot.required &&
                      selectedThemeForm.get(slot.field)?.invalid &&
                      selectedThemeForm.get(slot.field)?.touched
                  }"
                />
                <p
                  *ngIf="
                    slot.required &&
                    selectedThemeForm.get(slot.field)?.invalid &&
                    selectedThemeForm.get(slot.field)?.touched
                  "
                  class="text-red-500 text-xs mt-1"
                >
                  Obrigatório
                </p>
              </div>
            </section>

            <!-- Cores Desktop -->
            <section class="panel-section">
              <h2 class="section-title">Cores</h2>
              <div class="color-list">
                <div *ngFor="let cf of totemColorFields" class="color-row-wrap">
                  <div
                    class="color-row"
                    style="position: relative; overflow: hidden"
                    [class.color-row--error]="
                      cf.required && selectedThemeForm.get(cf.key)?.invalid && selectedThemeForm.get(cf.key)?.touched
                    "
                  >
                    <span
                      class="color-swatch-box"
                      [style.background-color]="selectedThemeForm.get(cf.key)?.value"
                    ></span>
                    <div class="color-info">
                      <span class="color-label-wrap">
                        <span class="color-label">{{ cf.label }}</span>
                        <svg
                          *ngIf="cf.tooltip"
                          class="label-info-icon"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          [matTooltip]="cf.tooltip"
                          matTooltipClass="info-tooltip"
                          matTooltipPosition="above"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.042.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.042-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </span>
                      <span class="color-hex">{{ selectedThemeForm.get(cf.key)?.value | uppercase }}</span>
                    </div>
                    <svg
                      class="color-edit-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="13"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                      />
                    </svg>
                    <input
                      type="color"
                      [value]="selectedThemeForm.get(cf.key)?.value"
                      (input)="selectedThemeForm.get(cf.key)?.setValue($any($event.target).value)"
                      style="
                        position: absolute;
                        inset: 0;
                        opacity: 0;
                        cursor: pointer;
                        width: 100%;
                        height: 100%;
                        border: none;
                        padding: 0;
                      "
                    />
                  </div>
                  <p
                    class="field-error"
                    *ngIf="
                      cf.required && selectedThemeForm.get(cf.key)?.invalid && selectedThemeForm.get(cf.key)?.touched
                    "
                  >
                    Obrigatório
                  </p>
                </div>
              </div>
            </section>
          </ng-container>

          <!-- ── SKINCARE TAB ── -->
          <ng-container *ngIf="activeTab === 'skincare'">
            <section class="panel-section">
              <h2 class="section-title">Animação da intro</h2>
              <ng-container
                *ngTemplateOutlet="animationUpload; context: { type: 'intro', control: 'skincareIntroAnimationPath' }"
              ></ng-container>
            </section>

            <section class="panel-section">
              <h2 class="section-title">Textos da intro</h2>
              <div *ngFor="let field of skincareTextFields" class="form-group">
                <label class="form-label">
                  {{ field.label }}
                  <span style="color: #9ca3af; font-size: 11px; margin-left: 4px">(opcional)</span>
                </label>
                <input
                  type="text"
                  [formControlName]="field.key"
                  class="form-input w-full"
                  [placeholder]="field.fallback"
                  [attr.maxlength]="skincareTextMaxLength"
                />
                <p class="field-hint">
                  {{ selectedThemeForm.get(field.key)?.value?.length || 0 }}/{{ skincareTextMaxLength }} · Em branco, o
                  app usa "{{ field.fallback }}".
                </p>
              </div>
            </section>

            <section class="panel-section">
              <h2 class="section-title">Cores da intro</h2>
              <div class="color-list">
                <div *ngFor="let cf of skincareColorFields" class="color-row-wrap">
                  <div class="color-row" style="position: relative; overflow: hidden">
                    <span
                      class="color-swatch-box"
                      [style.background-color]="selectedThemeForm.get(cf.key)?.value || 'transparent'"
                    ></span>
                    <div class="color-info">
                      <span class="color-label">{{ cf.label }}</span>
                      <span class="color-hex">{{
                        (selectedThemeForm.get(cf.key)?.value | uppercase) || 'Padrão do app'
                      }}</span>
                    </div>
                    <input
                      type="color"
                      [value]="selectedThemeForm.get(cf.key)?.value || cf.placeholder"
                      (input)="selectedThemeForm.get(cf.key)?.setValue($any($event.target).value)"
                      [attr.aria-label]="cf.label"
                      style="
                        position: absolute;
                        inset: 0;
                        opacity: 0;
                        cursor: pointer;
                        width: 100%;
                        height: 100%;
                        border: none;
                        padding: 0;
                      "
                    />
                  </div>
                  <button
                    *ngIf="selectedThemeForm.get(cf.key)?.value"
                    type="button"
                    class="field-hint"
                    style="background: none; border: none; padding: 0; cursor: pointer; text-decoration: underline"
                    (click)="selectedThemeForm.get(cf.key)?.setValue('')"
                  >
                    Usar padrão do app
                  </button>
                </div>
              </div>
              <p class="field-hint">
                Com a borda do botão definida, o botão vira só contorno. Os textos e o "Powered by" da Oliv-e usam a cor
                dos textos.
              </p>
            </section>

            <section class="panel-section">
              <h2 class="section-title">Logo do "Powered by"</h2>
              <div
                role="radiogroup"
                aria-label='Logo do "Powered by"'
                style="display: flex; flex-wrap: wrap; gap: 12px"
              >
                <label
                  *ngFor="let opt of poweredByLogoOptions"
                  [style.border-color]="
                    selectedThemeForm.get('skincarePoweredByLogo')?.value === opt.value
                      ? effectivePrimaryColor
                      : '#e5e7eb'
                  "
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 8px;
                    padding: 8px;
                    border: 2px solid;
                    border-radius: 12px;
                    cursor: pointer;
                  "
                >
                  <span
                    [style.background-color]="opt.preview"
                    style="display: flex; padding: 12px 16px; border-radius: 8px; border: 1px solid #e5e7eb"
                  >
                    <img [src]="opt.src" [alt]="'Logo Oliv-e para ' + opt.label" width="120" height="52" />
                  </span>
                  <span style="display: flex; align-items: center; gap: 6px; font-size: 13px">
                    <input type="radio" formControlName="skincarePoweredByLogo" [value]="opt.value" />
                    {{ opt.label }}
                  </span>
                </label>
              </div>
              <p class="field-hint">
                Escolha a versão que combina com o fundo da tela do skincare, para a logo não sumir em fundo escuro.
              </p>
            </section>
          </ng-container>

          <!-- ── STANDBY TAB ── -->
          <ng-container *ngIf="activeTab === 'standby'">
            <section class="panel-section">
              <h2 class="section-title">Standby</h2>
              <mat-slide-toggle formControlName="standbyEnabled">Ativar standby</mat-slide-toggle>
              <p class="field-hint">
                Depois de 60 s sem toque, o totem mostra a animação em tela cheia, em qualquer módulo. Sem animação,
                aparece só o aviso "Ainda está aí?" e o totem volta ao início.
              </p>
            </section>

            <section class="panel-section">
              <h2 class="section-title">Animação do standby</h2>
              <ng-container
                *ngTemplateOutlet="animationUpload; context: { type: 'standby', control: 'standbyAnimationPath' }"
              ></ng-container>
            </section>
          </ng-container>

          <!-- ── TELA INICIAL TAB ── -->
          <ng-container *ngIf="activeTab === 'home'">
            <section class="panel-section">
              <h2 class="section-title">Tela inicial do totem</h2>
              <mat-slide-toggle formControlName="homeEnabled">Usar tela inicial personalizada</mat-slide-toggle>
              <p class="field-hint">
                Desligada, o totem mostra a tela inicial padrão. As mudanças chegam ao totem quando o setup é atualizado
                (F8).
              </p>
            </section>

            <section class="panel-section">
              <h2 class="section-title">Textos</h2>
              <div *ngFor="let field of homeTextFields" class="form-group">
                <label class="form-label">
                  {{ field.label }}
                  <span style="color: #9ca3af; font-size: 11px; margin-left: 4px">(opcional)</span>
                </label>
                <input
                  type="text"
                  [formControlName]="field.key"
                  class="form-input w-full"
                  [placeholder]="field.placeholder"
                  [attr.maxlength]="homeTextMaxLength"
                />
                <p class="field-hint">
                  {{ selectedThemeForm.get(field.key)?.value?.length || 0 }}/{{ homeTextMaxLength }} ·
                  {{ field.emptyHint }}
                </p>
              </div>
            </section>

            <section class="panel-section">
              <h2 class="section-title">Ilustração</h2>
              <p class="field-hint home-media-guide">
                Aparece no meio da tela, entre a logo do cliente e o botão. A logo continua sempre visível, então use só
                desenho: sem logo, sem texto e com fundo transparente. Prefira movimento lento e contínuo, sem troca de
                cenas.
              </p>
              <div class="form-group">
                <label class="form-label">
                  URL da imagem
                  <span style="color: #9ca3af; font-size: 11px; margin-left: 4px">(opcional)</span>
                </label>
                <input
                  type="url"
                  formControlName="homeImageUrl"
                  class="form-input w-full"
                  placeholder="https://..."
                  maxlength="500"
                />
                <p class="field-hint" *ngIf="selectedThemeForm.get('homeImageUrl')?.invalid; else imageHint">
                  Use um endereço que comece com https://.
                </p>
                <ng-template #imageHint>
                  <p class="field-hint">Se houver animação, ela é usada no lugar da imagem.</p>
                </ng-template>
              </div>
            </section>

            <section class="panel-section">
              <h2 class="section-title">Animação</h2>
              <ng-container
                *ngTemplateOutlet="animationUpload; context: { type: 'home', control: 'homeAnimationPath' }"
              ></ng-container>
            </section>
          </ng-container>

          <ng-template #animationUpload let-type="type" let-control="control">
            <div class="form-group animation-upload">
              <ng-container [ngSwitch]="animationStatusOf(type)">
                <div *ngSwitchCase="'saved'" class="animation-status animation-status--saved">
                  <svg
                    class="animation-status__icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                  <div>
                    <strong>Animação configurada</strong>
                    <span
                      *ngIf="type === 'standby' && !selectedThemeForm.get('standbyEnabled')?.value; else homeOffHint"
                    >
                      O standby está desligado: a animação não aparece no totem.
                    </span>
                    <ng-template #homeOffHint>
                      <span *ngIf="type === 'home' && !selectedThemeForm.get('homeEnabled')?.value; else savedHint">
                        A tela inicial personalizada está desligada: a animação não aparece no totem.
                      </span>
                    </ng-template>
                    <ng-template #savedHint
                      ><span>Salva neste tema. Envie outro arquivo para trocar.</span></ng-template
                    >
                  </div>
                </div>
                <div *ngSwitchCase="'pending'" class="animation-status animation-status--pending">
                  <svg
                    class="animation-status__icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 8v4l3 2m6-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <div>
                    <strong>Animação enviada</strong>
                    <span>Clique em "Salvar tema" para aplicar.</span>
                  </div>
                </div>
                <div *ngSwitchDefault class="animation-status animation-status--none">
                  <svg
                    class="animation-status__icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.5"
                  >
                    <path stroke-linecap="round" d="M5 12h14" />
                  </svg>
                  <div>
                    <strong>Nenhuma animação</strong>
                    <span [ngSwitch]="type">
                      <ng-container *ngSwitchCase="'intro'">A intro mostra o carrossel de fotos.</ng-container>
                      <ng-container *ngSwitchCase="'home'">O totem mostra a imagem, se houver.</ng-container>
                      <ng-container *ngSwitchDefault>Sem attract mode na ociosidade.</ng-container>
                    </span>
                  </div>
                </div>
              </ng-container>

              <app-lottie-preview *ngIf="animationPreviewOf(type) as data" [animationData]="data"></app-lottie-preview>

              <ng-container *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin]">
                <input
                  #animationInput
                  type="file"
                  accept=".json,application/json"
                  style="display: none"
                  (change)="onAnimationSelected(type, $event)"
                />
                <button
                  type="button"
                  class="btn btn--primary animation-upload__button"
                  [disabled]="!selectedThemeForm.get('id')?.value || uploadingAsset !== null"
                  (click)="animationInput.click()"
                >
                  {{ uploadingAsset === type ? 'Enviando…' : 'Enviar Lottie (.json, até 1 MB)' }}
                </button>
                <p class="field-hint" *ngIf="!selectedThemeForm.get('id')?.value">
                  Salve o tema antes de enviar a animação.
                </p>
              </ng-container>
            </div>
          </ng-template>

          <!-- ── MOBILE TAB ── -->
          <ng-container *ngIf="activeTab === 'mobile'">
            <!-- Logos Mobile -->
            <section class="panel-section">
              <h2 class="section-title">Logos - Mobile</h2>
              <div *ngFor="let slot of mobileLogoSlots" class="form-group">
                <label class="form-label">
                  {{ slot.title }} <span class="logo-badge" style="margin-left: 4px">{{ slot.badge }}</span>
                </label>
                <input
                  type="text"
                  [formControlName]="slot.field"
                  class="form-input w-full"
                  placeholder="https://storage.googleapis.com/..."
                  [ngClass]="{
                    'border-red-500':
                      slot.required &&
                      selectedThemeForm.get(slot.field)?.invalid &&
                      selectedThemeForm.get(slot.field)?.touched
                  }"
                />
                <p
                  *ngIf="
                    slot.required &&
                    selectedThemeForm.get(slot.field)?.invalid &&
                    selectedThemeForm.get(slot.field)?.touched
                  "
                  class="text-red-500 text-xs mt-1"
                >
                  Obrigatório
                </p>
              </div>
            </section>

            <!-- Cores Mobile -->
            <section class="panel-section">
              <h2 class="section-title">Cores</h2>
              <div class="color-list">
                <div *ngFor="let cf of colorFields" class="color-row-wrap">
                  <div
                    class="color-row"
                    style="position: relative; overflow: hidden"
                    [class.color-row--error]="
                      cf.required && selectedThemeForm.get(cf.key)?.invalid && selectedThemeForm.get(cf.key)?.touched
                    "
                  >
                    <span
                      class="color-swatch-box"
                      [style.background-color]="selectedThemeForm.get(cf.key)?.value"
                    ></span>
                    <div class="color-info">
                      <span class="color-label">{{ cf.label }}</span>
                      <span class="color-hex">{{ selectedThemeForm.get(cf.key)?.value | uppercase }}</span>
                    </div>
                    <svg
                      class="color-edit-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="13"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                      />
                    </svg>
                    <input
                      type="color"
                      [value]="selectedThemeForm.get(cf.key)?.value"
                      (input)="selectedThemeForm.get(cf.key)?.setValue($any($event.target).value)"
                      style="
                        position: absolute;
                        inset: 0;
                        opacity: 0;
                        cursor: pointer;
                        width: 100%;
                        height: 100%;
                        border: none;
                        padding: 0;
                      "
                    />
                  </div>
                  <p
                    class="field-error"
                    *ngIf="
                      cf.required && selectedThemeForm.get(cf.key)?.invalid && selectedThemeForm.get(cf.key)?.touched
                    "
                  >
                    Obrigatório
                  </p>
                </div>
              </div>
            </section>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div class="panel-empty" *ngIf="themesFormArray.length === 0" style="position: relative">
      <button
        type="button"
        class="modal-close-btn"
        routerLink="/dash/temas"
        style="position: absolute; top: 16px; right: 16px; background: rgba(0, 0, 0, 0.06); color: #374151"
      >
        ✕
      </button>
      <div class="empty-state">
        <div class="empty-state-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42"
            />
          </svg>
        </div>
        <h2 class="empty-state-title">Nenhum tema cadastrado</h2>
        <p class="empty-state-desc">Crie o primeiro tema para personalizar a identidade visual deste parceiro.</p>
        <button
          *isAllowed="[ERoleAdminString.Admin, 'theme.create']"
          type="button"
          class="empty-state-btn"
          (click)="addNewTheme()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            width="15"
            height="15"
          >
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          Criar primeiro tema
        </button>
        <ng-container *isAllowed="[ERoleAdminString.Admin, 'theme.create']">
          <input #importInput type="file" accept=".json" style="display: none" (change)="onImportJson($event)" />
          <button
            type="button"
            class="empty-state-btn"
            style="margin-top: 8px; background: #226470"
            (click)="importInput.click()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              width="15"
              height="15"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
              />
            </svg>
            Importar tema (.json)
          </button>
        </ng-container>
      </div>
    </div>

    <!-- Import preview modal -->
    <div *ngIf="importPreview" class="modal-overlay import-modal-overlay" (click)="cancelImport()">
      <div class="modal-container import-modal-container" (click)="$event.stopPropagation()">
        <div class="import-modal-header">
          <h2 class="import-modal-title">Confirmar importação</h2>
          <button type="button" (click)="cancelImport()" class="import-modal-close">✕</button>
        </div>
        <div class="import-modal-body">
          <p class="import-modal-label">Resumo do tema a importar:</p>
          <div *ngIf="importSummary" class="import-summary-card">
            <div><strong>Nome:</strong> {{ importSummary.themeName }}</div>
            <div><strong>Logo desktop:</strong> {{ importSummary.hasDesktopLogo ? 'Sim' : 'Não' }}</div>
            <div><strong>Logo mobile:</strong> {{ importSummary.hasMobileLogo ? 'Sim' : 'Não' }}</div>
            <div class="import-summary-color-row">
              <strong>Cor primária:</strong>
              <span
                *ngIf="importSummary.primaryColor"
                class="import-color-swatch"
                [style.background-color]="importSummary.primaryColor"
              ></span>
              <span>{{ importSummary.primaryColor || 'Não definida' }}</span>
            </div>
          </div>
          <div
            *ngIf="importResult"
            class="import-result"
            [class.import-result--success]="importResult.success"
            [class.import-result--error]="!importResult.success"
          >
            {{ importResult.message }}
          </div>
        </div>
        <div *ngIf="importNameConflict" class="import-conflict-zone">
          <p class="import-conflict-text">
            Um tema com o nome <strong>"{{ importNameConflict.original }}"</strong> já existe. O que deseja fazer?
          </p>
          <div class="import-conflict-actions">
            <button type="button" (click)="resolveConflict('replace')" class="import-btn import-btn--replace">
              Substituir existente
            </button>
            <button type="button" (click)="resolveConflict('rename')" class="import-btn import-btn--rename">
              Renomear para "{{ importNameConflict.suggested }}"
            </button>
          </div>
        </div>
        <div class="import-modal-footer">
          <button type="button" (click)="cancelImport()" class="import-btn import-btn--cancel">Cancelar</button>
          <button
            *ngIf="!importNameConflict"
            type="button"
            (click)="confirmImport()"
            [disabled]="!!importResult?.success"
            class="import-btn import-btn--confirm"
          >
            Confirmar importação
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
